module.exports = __webpack_public_path__ + "static/media/regBanner.61a6dd18.jpeg";